/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {useDispatch} from "react-redux";

import {service as AuthService} from "../../Services/Core/AuthService";
import {service as TermsService} from "../../Services/Core/TermsService";

import TermsOfServiceModal from "../../../../monitoring/src/Components/Common/TermsOfServiceModal";
import {CLOSE_TERMS} from "../../Redux/Actions/Types/termsActionTypes";

/*
* This component overrides the accept and decline actions of the TermsOfServiceModal
* in the context of StreamBank Admin so that we can use the SBA TermsService and
* AuthService classes, which despite being essentially the same, use a different 'Config'
* object which makes this necessary.
* TODO: SB-3140 - Eliminate this component by refactoring the TermsService and AuthService
* classes to use the same Config object. 
*/
export const SBATermsOfServiceModal = (props) => {
    
    const dispatch = useDispatch();
    
    const onAccept = async () => {
        try {
            const result = await TermsService.Accept();
            if(result) {
                dispatch({type: CLOSE_TERMS});
            }
        } catch (error) {
            alert("An error occurred while accepting the terms of service:\n" + (error.message ?? '') + "\nYou may be asked to accept the terms again when you log in next time.");
            dispatch({ type: CLOSE_TERMS });
            throw error;
        }
    };
    
    const onDecline = async () => {
        dispatch({ type: CLOSE_TERMS });
        AuthService.Logout();
    };
    
    return <TermsOfServiceModal
        onAccept={onAccept}
        onDecline={onDecline}
        {...props}
    />;
    
};
